import React from 'react';
import wb0 from '../img/Detail/portrait_detail.jpg';
import './Detail.css';
const PortraitDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default PortraitDetail;